module.exports = __webpack_public_path__ + "static/media/close.936364cf.svg";